// The one list of CAD platforms a customer can request a licence for.
//
// This used to exist twice — PRODUCT_ORDER in the dashboard card and a separate
// PRODUCT_OPTIONS array in the Request a Quote tab, with its own hand-written
// labels ("SPCAD for AutoCAD" vs PRODUCT_DATA's "AutoCAD"). Two lists meant two
// places to forget when a platform is added, and two different names for the
// same product code. Names and logos come from PRODUCT_DATA, so this file only
// decides which codes are offered and in what order.
export const PRODUCT_ORDER = [
  "SPCAD_ACAD_Beta",
  "SPCAD_BRX",
  "SPCAD_ZWCAD",
  "SPCAD_GSTARCAD",
  "SPCAD_CADMATE",
  "SPCAD_PCAD",
];

// Upper bound on the quantity stepper; larger orders go through the custom-term
// box, where a human prices them.
export const MAX_LICENSES = 15;
